import sortBy from "lodash/sortBy";

import { facetCategoryCodes, facetGroupCode } from "shared/config/common";
import facetService from "shared/services/api/facet/facetService";
import { AsyncAction } from "shared/types/utilities";

import {
  FacetStoreKey,
  GetFacets,
  IFacetState,
  SetCategories,
  SetCategory,
} from "store/facet/facet.types";
import { ActionType } from "store/types";

export const facetCategoryCodeToStoreKeyMap = {
  [facetCategoryCodes.productionType]: FacetStoreKey.ProductionType,
  [facetCategoryCodes.contractType]: FacetStoreKey.ContractType,
  [facetCategoryCodes.gender]: FacetStoreKey.Gender,
  [facetCategoryCodes.appearance]: FacetStoreKey.Appearance,
  [facetCategoryCodes.disability]: FacetStoreKey.Disability,
  [facetCategoryCodes.complaintCategory]: FacetStoreKey.ComplaintCategory,
  [facetCategoryCodes.ethnicBackground]: FacetStoreKey.EthnicBackground,
  [facetCategoryCodes.heritageAndEthnicity]: FacetStoreKey.HeritageAndEthnicity,
};

export const facetCategoryCodeToOtherGroupCodeMap = {
  [facetCategoryCodes.productionType]: facetGroupCode.productionType.other,
  [facetCategoryCodes.contractType]: facetGroupCode.contractType.lowPay,
  [facetCategoryCodes.gender]: facetGroupCode.gender.other,
  [facetCategoryCodes.appearance]: facetGroupCode.appearance.other,
  [facetCategoryCodes.disability]: facetGroupCode.disability.other,
};

// ============================== Redux Actions =======================================================================

export const setCategory: SetCategory = (key, data, locale) => ({
  type: ActionType.SetCategory,
  payload: { key, data, locale },
});

export const setCategories: SetCategories = (data, locale) => ({
  type: ActionType.SetCategories,
  payload: { data, locale },
});

export const getFacets: AsyncAction<GetFacets> =
  (categories, locale) => async (dispatch) => {
    const loadedCategories = await facetService.find(categories, locale);
    const data = loadedCategories.reduce<Partial<IFacetState>>(
      (result, category) => {
        const otherGroupCode =
          facetCategoryCodeToOtherGroupCodeMap[category.code];
        result[facetCategoryCodeToStoreKeyMap[category.code]] = sortBy(
          category.facetGroups,
          (group) => group.code === otherGroupCode
        );

        return result;
      },
      {}
    );

    dispatch(setCategories(data, locale));
  };
